// All of the pipes should be exported here
export * from './c-date.pipe';
export * from './c-time.pipe';
export * from './date-to-iso';
export * from './file-size.pipe';
export * from './safe.pipe';
export * from './truncate.pipe';

